import React from 'react';
import PropTypes from 'prop-types';
import * as BvtIcon from 'bvt-icon';
import './PopupContent.scss';
import { Svg } from '@bvt-atoms';
import { getIcon } from '@bvt-shared/utils/iconUtils';
import { PopupStartSipro } from '@bvt-shared/component/PopupStartSipro';
import { Popup } from 'react-leaflet';

const Component = ({ properties }) => {
  return (
    <PopupStartSipro marker={properties}>
      <div className='SiproPOI__popup'>
        <div className='header'>
          <div className='icon'>
            {
              properties.category_icon
                ? <Svg src={getIcon('poi', properties?.category_icon)} type='link' />
                : <BvtIcon.DefaultPoi height='22' width='22' />
            }
          </div>
          <div className='wrapper-title'>
            <div className='title'>
              {properties?.poi_name}
            </div>
            <div className='subtitle'>
              {properties?.industry_name}
            </div>
          </div>
        </div>
        <p className='address'>
          {properties?.address}
        </p>
      </div>
    </PopupStartSipro>
  );
};

function PopupContent(props) {
  const { lat, lng, properties, onClose } = props;

  if (lat && lng) {
    const commonPopupProps = {
      className: 'MarkerPopup-li__popup',
      offset: { x: 0, y: -45 },
      position: { lat, lng },
    };

    return (
      <Popup {...commonPopupProps} onClose={onClose}>
        <div className={`MarkerPopup-li__popup-wrap`}>
          <Component properties={properties} />
        </div>
      </Popup>
    );
  }

  return null;
}

function areEqual(prevProps, nextProps) {
  return (
    prevProps.lat === nextProps.lat &&
    prevProps.lng === nextProps.lng &&
    JSON.stringify(prevProps.properties) === JSON.stringify(nextProps.properties)
  );
}

export default React.memo(PopupContent, areEqual);

PopupContent.propTypes = {
  properties: PropTypes.object,
};
